import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectHero from '../../components/hero3/projecthero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Video from '../../images/Video.png';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ClientNumber from '../../components/business-consulting-components/clientnumber';
import srj1 from '../../images/srj1.svg'
import srj2 from '../../images/srj2.svg'
import srj3 from '../../images/srj3.png'
import srj4 from '../../images/srj4.png'
import srj5 from '../../images/srj5.png'
import srj6 from '../../images/srj6.png'
import srj7 from '../../images/srj7.png'
import srj8 from '../../images/srj8.png'
import srj9 from '../../images/srj9.png'
import srj10 from '../../images/srj10.png'
import CaseStudiesSlider from '../../components/business-consulting-components/CaseStudiesSlider';


const SRJ = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <ProjectHero top_title={<>Reviving SEO & Building AI Visibility for a Plate Heat Exchanger Manufacturer</>}/>

                    <section className="video_section">
                        <div className="container text-center project_page_desp">
                            <h2>Company Overview</h2>

                            <ul className='project_page_ul'>
                                <li>
                                    <span className='number_css'>7+</span>
                                    <span className='hero_bottom_text'>Team Size</span>
                                </li>
                                <li>
                                    <span className='number_css'>India</span>
                                    <span className='hero_bottom_text'>Country</span>
                                </li>
                                <li>
                                    <span className='number_css'>B2B</span>
                                    <span className='hero_bottom_text'>Industry</span>
                                </li>
                                <li>
                                    <span className='number_css'>Plate Heat Exchanger Manufacturer</span>
                                    <span className='hero_bottom_text'>Category</span>
                                </li>
                            </ul> 
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>About Business</h2>
                                    <p className='heading_description text-dark mb-0'>Jitendra is the owner of one of India’s leading Plate <br/> Heat Exchanger (PHE) manufacturing companies. <br/> His products serve critical industries such as <br/> Pharmaceuticals, Food & Beverages, and <br/> Chemicals, where efficiency, safety, and reliability <br/> are essential.</p>
                                </div>

                                <div className="col-lg-6" style={{textAlign:'right'}}>
                                    <img src={srj1} alt="srj1" className='img_width' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj2} alt="aiseo" className='img-fluid img_width'/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Client Challenges</h2>
                                    <p className='heading_description text-dark mb-0'>By the time Jitendra approached Digi Pexel, his company was facing severe digital growth challenges:</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Decline in website traffic and loss of visibility in Google SERPs.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Drop in keyword rankings across core product terms.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Low-quality, low-value leads, with a declining conversion rate.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>A spammy backlink profile, heavily reliant on PBN links, is damaging authority.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Major indexing issues—large sections of the website were not indexed properly.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>A need to establish presence on AI-driven search platforms, as AI-generated results are becoming more influential in B2B buying journeys.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Overview</h2>
                                    <h3 className='mt-4'>SEO Brief</h3>
                                    <p className='heading_description text-dark mb-0'>During onboarding, Jitendra mentioned working with several SEO agencies in the past, but none had delivered measurable results. His top priorities were:</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Revive organic performance through AI-focused SEO (AEO/GEO).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Fix the toxic backlink profile and establish authority with high-quality industry links.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Improve website indexing and technical SEO hygiene.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Build a scalable strategy for lead generation in India while preparing for expansion into the UAE, Saudi Arabia, and other Gulf countries.</li>
                                    </ul>

                                     <h3 className='mt-4'>Client Ask</h3>
                                      <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Identify why the website was not ranking in Google SERPs.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Build an AI SEO strategy to secure mentions in AI search platforms.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Provide a detailed backlink cleanup and acquisition plan to replace spammy links with high-authority references.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Create a long-term SEO + marketing roadmap to generate high-quality B2B leads and support global expansion.</li>
                                    </ul>


                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj3} alt="srj3" className='img-fluid' />
                                </div>
                                <div className="col-lg-6">
                                    <img src={srj4} alt="srj3" className='img-fluid' />
                                </div>
                                <div className="col-lg-6">
                                    <img src={srj5} alt="srj3" className='img-fluid' />
                                </div>
                                <div className="col-lg-6">
                                    <img src={srj6} alt="srj3" className='img-fluid' />
                                </div>
                                <div className="col-lg-12 text-center">
                                    <img src={srj7} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row challenges_css">
                                <div className="col-lg-6">
                                    <img src={srj8} alt="aiseo" className='img-fluid' style={{maxWidth:'70%',marginTop:'20%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Challenges We Faced</h2>
                                    <p className='heading_description text-dark mb-0'>While working on this project, there are many challenges that we have faced, like the poor website structure, spammy backlink profile, and lots of big brands are in this category. The following are some of the issues that have been faced.</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Over 70% of backlinks were spammy or from irrelevant PBN sites.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Many product and sector pages were not indexed due to poor site architecture and crawlability issues.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Competitors in the Gulf region had already built geo-targeted authority.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Weak E-E-A-T signals (no author profiles, thin technical content, lack of industry citations).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>No presence on AI-driven search engines like Perplexity, Bing AI, or Google’s AI overviews.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space solution pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>Solution Provided</h2>
                                </div>

                                <div className="col-lg-6">
                                    <ul class="srj_list solution_list mt-4">
                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Diagnosis & Audit</div>
                                                <p>Full technical SEO audit to identify crawl depth, indexing issues, sitemap/robots errors, and canonical conflicts.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Built the New Website</div>
                                                <p>After the full audit of the site, we have built the website using the best technology, which has improved the site's crawlability and speed</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Content & Authority Strategy</div>
                                                <p>Built pillar-cluster model: We have built a good pillar and cluster content on the website, which helped us in getting the SERP ranking and AI mentions.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>AI SEO (Answer Engine Optimization & Generative Engine Optimization)</div>
                                                <p>Optimized FAQs, structured data, and Q&A formats to surface in AI-generated answers. Integrated schema markup (Product, Technical Article, FAQ) to improve AI parsing.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Backlink Cleanup & Acquisition</div>
                                                <p>Submitted disavow files to Google for toxic domains. And built an industry-relevant white-hat backlink.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Technical SEO Fixes</div>
                                                <p>Improved crawl depth by restructuring site navigation. Fixed canonical issues, duplicate content, and thin pages.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Backlink Auditing & Fixing</div>
                                                <p>Backlink audit using toxicity scoring—flagged 70% links for disavowal or replacement</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Analytics & Ops</div>
                                                <p>We made sure we track everything so that we can avoid the guesswork. For this, we were tracking website UX and user journey, website engagement using heatmaps, Google SERP keyword tracking, and AI Brand mention tracking, etc.</p>
                                            </div>
                                        </li>
                                        
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <ToolSection title1={<>Looking to fix toxic SEO, rank in AI platforms, and expand globally? </>} title2={<>Partner with us for a custom AI SEO strategy tailored to your industry.</>} />
                    
                    <section className="intro_about_section section_space project_outcome pt-0 max_900">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Outcome</h2>
                                </div>

                                <div className="col-lg-10 offset-lg-2">
                                    <ul class="srj_list solution_list mt-4">

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Fixed Toxic Backlinks</div>
                                                <p>Toxic backlinks removed; healthy industry links established.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Improved Crawlability</div>
                                                <p>Website re-indexed with improved crawlability; service/product pages ranking again.</p>
                                            </div>
                                        </li>

                                         <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Brand Visibility in AI Platforms</div>
                                                <p>Early visibility in AI-driven answer engines for target keywords.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Improved Lead Flow</div>
                                                <p>Increase in high-quality inbound leads from the pharma and food industries in India.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>High Quality Leads</div>
                                                <p>Qualified leads flow generated from the UAE and Saudi Arabia within 3 months of localized SEO.</p>
                                            </div>
                                        </li>



                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </section>
                    <ClientNumber/>

                    <section className="intro_about_section section_space project_outcome">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj10} alt="srj10" className='img-fluid' />
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container max_900">
                            <div className="row">
                                <div className="col-lg-12 text-center tool_section_new">
                                    <h2>Partner with us and get your custom AI SEO <br/> strategy for your business</h2>
                                    <button className="read_more btn btn-secondary">Contact Now</button>
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <CaseStudiesSlider/>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default SRJ;
